/*
 * IMPORTS
 */
import React from 'react'
import PropTypes from 'prop-types'
import { Button, Flex, Text } from '@chakra-ui/react'
import { toast } from 'react-hot-toast'
import { MemoizedInput } from 'components/MemoizedInput'

/*
 * COMPONENT
 */
const EmailReportModal = ({
  onSubmit,
  isLoading
}) => {
  // State
  const [emailForReport, setEmailForReport] = React.useState('')

  // Handle submit
  const handleSubmit = () => {
    // Validate email
    if (!emailForReport || !emailForReport.includes('@')) {
      toast('Please enter a valid email address')
      return
    }

    // Call parent function with email
    onSubmit(emailForReport)
  }

  // Handle input change
  const handleEmailChange = (e) => {
    setEmailForReport(e.target.value)
  }

  // Return component
  return (
    <Flex flexDirection="column" gap={4}>
      <Text fontSize="16px" fontWeight="600" color="gray.500">
        Enter your email address to receive the report
      </Text>
      <MemoizedInput
        placeholder="e.g.email@example.com"
        type="email"
        value={emailForReport}
        onChange={handleEmailChange}
      />
      <Flex gap={3} justifyContent="flex-end" mt={2}>
        <Button
          backgroundColor='purple.200'
          color='purple'
          onClick={handleSubmit}
          isLoading={isLoading}
          _hover={{ 'bg': 'purple.800', 'color': 'white' }}
        >
          Send Report
        </Button>
      </Flex>
    </Flex>
  )
}

/*
 * PROPTYPES
 */
EmailReportModal.propTypes = {
  'onSubmit': PropTypes.func.isRequired,
  'isLoading': PropTypes.bool
}

/*
 * EXPORT
 */
export default EmailReportModal
